import { omitBy, isUndefined } from 'lodash-es';
import { isFalsy } from 'utility-types';
export function isElementOfType(element, ComponentType) {
  return element != null && element.type != null && element.type.displayName != null && element.type.displayName === ComponentType.displayName;
}
export function isFunction(value) {
  return typeof value === 'function';
}
export function elementIsOrContains(element, testElement) {
  if (isFalsy(element) || isUndefined(testElement)) return false;
  return element === testElement || element.contains(testElement);
}
export function isArray(arg) {
  return Array.isArray(arg);
}
export function isTruthy(value) {
  return value !== false && value !== undefined && value !== null && value !== '';
}
export function isDefined(value) {
  return value !== undefined && value !== null;
}
export function isNumber(value) {
  return typeof value === 'number';
}
export function isInteger(value) {
  return Number.isInteger(value);
}
export function isNodeEnv(env) {
  return typeof process !== 'undefined' && process.env && process.env.NODE_ENV === env;
}
export function removeUndefined(object) {
  return omitBy(object, isUndefined);
}